import {FormikProps} from "formik";
import React, {FC, memo, useContext} from "react";
import {Form} from "antd";
import {createInputHelpers} from "../../helpers/createInputHelpers";
import {URIContext} from "../../containers/common/ApolloWrapper";
import i18n from "../../services/i18n";
import RichTextEditor from "../RichTextEditor/RichTextEditor";
import {uploadContentImage} from "./uploadContentImage";

type TextAreaInputMarkdownProps<T> = {
    fieldName: keyof T;
    /** Höhe in Textzeilen, wie beim früheren Textfeld. */
    rows: number;
    label: string;
    placeholder: string;
    formikProps: FormikProps<T>;
    style?: React.CSSProperties;
    testId: string;
};

/** „Infos für die Website“ (Kursart, Kurs): Editor mit Werkzeugleiste, gespeichert als Markdown. */
const TextAreaInputMarkdown: FC<TextAreaInputMarkdownProps<any>> = ({fieldName, rows, label, formikProps, placeholder, testId, style, ...props}) => {
    const uri = useContext(URIContext);
    const fieldNameString = fieldName as string;
    const {help, validateStatus} = createInputHelpers(formikProps);

    return (
        <div data-testid={testId} style={{gridColumn: "span 2", ...style}} {...props}>
            <Form.Item labelCol={{span: 24, offset: 0}} label={label} validateStatus={validateStatus(fieldNameString)} help={help(fieldNameString)}>
                <RichTextEditor
                    value={formikProps.values[fieldNameString] || ""}
                    onChange={(markdown) => formikProps.setFieldValue(fieldNameString, markdown)}
                    onBlur={() => formikProps.setFieldTouched(fieldNameString, true)}
                    placeholder={placeholder}
                    onUploadImage={(file) => uploadContentImage(uri, file, i18n.containers.courses.CourseCreate.courseWebsiteInfo.image.uploadError())}
                    minHeight={rows * 22}
                    testId={`${testId}-editor`}
                />
            </Form.Item>
        </div>
    );
};

export default memo(TextAreaInputMarkdown);
